import { Icons } from "./icons";

export const SKILLS = [
  { key: "React" },
  { key: "Angular" },
  { key: "MySQL" },
  { key: "Java" },
  { key: "TailwindCSS" },
  { key: "SCRUM" },
  { key: "Python" },
  { key: "Pandas" },
  { key: "Matplotlib" },
  { key: "OpenCV" },
  { key: "Roboflow" },
];

export const CERTIFICATES = [
  { key: "Django Masterclass" },
  { key: "The Ultimate React Course 2024" },
];